import { UliItemTruckListSearchCriteria, UliItemActionParams } from '../../models';

export class UliItemTruckListLoad {
  public static readonly type = '[UliItemTruck] List Load';

  constructor(
    public payload: {
      params: UliItemActionParams;
      searchCriteria: UliItemTruckListSearchCriteria;
    },
  ) {}
}

export class UliItemTruckAssign {
  public static readonly type = '[UliItemTruck] Assign';

  constructor(public payload: { params: UliItemActionParams; truckId: number }) {}
}

export class UliItemTruckInitialState {
  public static readonly type = '[UliItemTruck] Set Initial State';
}
